import { render, staticRenderFns } from "./TransferWarrantyStock.vue?vue&type=template&id=6779dbf0&scoped=true&"
import script from "./TransferWarrantyStock.vue?vue&type=script&lang=js&"
export * from "./TransferWarrantyStock.vue?vue&type=script&lang=js&"
import style0 from "./TransferWarrantyStock.vue?vue&type=style&index=0&id=6779dbf0&prod&lang=css&scoped=true&"
import style1 from "./TransferWarrantyStock.vue?vue&type=style&index=1&id=6779dbf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779dbf0",
  null
  
)

export default component.exports